"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const addToMean_1 = __importDefault(require("./addToMean"));
const math_1 = require("./math");
function calculateMean(values) {
    const numbers = (0, math_1.getNumbersInList)(values);
    return numbers.reduce((mean, value, index) => (0, addToMean_1.default)(mean, index, value), undefined);
}
exports.default = calculateMean;
